import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`
const apiSgtec = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterOpcoesFiltro() {
        return axiosJwt
            .get(`${apiSgtec}/sgtec/uabs/relatorios/opcoesfiltros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterContratos() {
        return axiosJwt
            .get(`${api}/gescon/contrato`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRelatorioFaturamentoServicos(filtro) {
        let url = `${api}/gescon/contrato/relatorios/faturamento-servicos?grupoPeriodo=${filtro.grupoPeriodo ? filtro.grupoPeriodo : ''
            }&fornecedor=${filtro.fornecedor ? filtro.fornecedor : ''
            }&numeroContrato=${filtro.numeroContrato ? filtro.numeroContrato : ''
            }&gestor=${filtro.gestor ? filtro.gestor : ''
            }&unidade=${filtro.unidade ? filtro.unidade : ''}`

        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}